import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { StoreSupRelationVO } from 'src/app/shared/models/StoreSupRelationVO';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { Table } from 'primeng/table';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';
import { first } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { SchoolFpgDataVO } from 'src/app/shared/models/SchoolFPGDataVO';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { GuideModel } from 'src/app/shared/models/guide-model';
import { WorkshopVO } from 'src/app/shared/models/WorkshopVO';
import { OpenAssignedFolios } from 'src/app/shared/models/OpenAssignedFolios';


@Component({
  selector: 'app-schoolfpg-participant-transfer',
  templateUrl: './schoolfpg-participant-transfer.component.html',
  styleUrls: ['./schoolfpg-participant-transfer.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class SchoolfpgParticipantTransferComponent implements OnInit {

  /** USER PREFERENCES */
  globalUserPreferencesParams: CookieTovpil = {};
  globalUserDataFormParams: FormGroup;

  /** WITHOUT SELECTOR PREFERENCES*/
  currentUser: any;
  token: string;
  type: string;
  churchName: string;
  schoolId: string;
  guideId: string;
  coordStoreId: string;

  /** COMPONENT */
  languages: any[];
  periods: any[];
  currencies: any[];
  guides: CategoryLan[];
  stores: any[];

  /** DATAPARENT */
  dataParent: any = {};

  /** PIPES */
  datePipe: DatePipe = new DatePipe('en-US');

  /** LABELS */
  translations: Record<string, string> = null;

  /** COMPONENT OVERLAY */
  blocked: boolean = false;

  /** ENDPOINTS */
  endPointGetValidPeriods = "getValidPeriods";
  endPointGetStoreById = "getStoreById";
  endPointLanguageByStoreId = "getListSpkLangByStoreId";
  endPoinGetAllEgpByStoreId = "getAllSchoolFpg";
  endPoinGetGuideById = "getGuideById";
  endPointFindSupRelationByName = "findSupRelationByName";
  endPointFindOpenSchoolsByGuideId = "findOpenSchoolsByGuideId";
  endPointFindSupRelationByStoreId = "findSupRelationByStoreId";
  endPointOpenAssignedFolios = "openAssignedFolios";

  /** TRANSFER */
  isMobile: boolean = false;
  lstCols: { field: string; header: string; }[];
  lstColsOpenFolios: { field: string; header: string; }[];
  displayModalConfirmation: boolean = false;


  /** VIEW FILTERS */
  @ViewChild('dt2') private tableGuideCoord: Table;

  /**
   * This constructor function initializes various services and variables used in the component, and also
   * checks for authentication based on the token and device parameters passed in the URL.
   * @param {MessageService} messageService - This parameter is of type MessageService and is used for
   * displaying messages to the user. It is likely used to show success or error messages during certain
   * operations.
   * @param {ConfirmationService} confirmationService - The `confirmationService` is a service that
   * provides methods for displaying confirmation dialogs to the user. It is used to prompt the user for
   * confirmation before performing certain actions.
   * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
   * making API requests and handling responses.
   * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
   * which is used to access the current route's information. It provides access to the route's
   * parameters, query parameters, and other related data. In this code snippet, the `route` parameter is
   * used to subscribe to the
   * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
   * user and manage user authentication-related tasks, such as logging in, logging out, and retrieving
   * the current user's information.
   * @param {TovpilFilesService} filesService - The `filesService` parameter is an instance of the
   * `TovpilFilesService` class. It is used to handle file-related operations, such as uploading and
   * downloading files.
   * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter is an instance of
   * the `TovpilCrudService` class. It is used to perform CRUD (Create, Read, Update, Delete) operations
   * on data in the application.
   * @param {FormBuilder} fb - The `fb` parameter is an instance of the `FormBuilder` class. It is used
   * to create instances of `FormGroup` and `FormControl` for building reactive forms in Angular.
   */
  constructor(private messageService: MessageService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private tovpilUtils: TovpilUtilsService,
    private authenticationService: AuthenticationService,
    private tovpilCrudService: TovpilCrudService,
    private fb: FormBuilder,
    private userPreferencesService: UserPreferencesService,
    private router: Router,
    private translationService: TovpilLanguageService) {

    this.createDataForm();
    this.initConfigs();

    // GET STATE VALUES 
    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.state as any;

    // GET ROUTE VALUES
    this.route.queryParams
      .subscribe(
        params => {
          this.token = params.token;
          this.type = params.type;
          this.churchName = params.churchName
          this.schoolId = params.schoolId
          this.guideId = params.guideId
          this.coordStoreId = params.storeId
        });

    this.currentUser = this.authenticationService.currentUserValue;
    if (this.type === "2") {
      this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
    }
  }

  /**
  * The function initializes form groups for configuration and data, and updates the configuration form
  * with query parameters from the route.
  */
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferencesParams = await this.userPreferencesService.getSantovTovpilCookie() || null;
    console.debug("✅ TRASPASO DE USUARIOS - USER PREFERENCES: " + JSON.stringify(this.globalUserPreferencesParams, null, 2));
  }

  /**
    * The function `createDataForm` in TypeScript initializes a form group with various form controls and
    * default values, as well as setting some controls as disabled.
    */
  createDataForm() {
    this.globalUserDataFormParams = this.fb.group({
      // GENERALS
      selectedLanguage: new FormControl({ value: null, disabled: false }),
      selectedPeriod: new FormControl({ value: null, disabled: false }),
      selectedStore: new FormControl({ value: null, disabled: false }),
      selectedGuide: new FormControl({ value: null, disabled: false }),
      selectedCoordination: new FormControl({ value: null, disabled: false }),

      // MAIN OBJ
      selectedSchoolFpg: ({ value: null as SchoolFpgDataVO, disabled: false }),
      selectedFutureGuide: ({ value: null as GuideModel, disabled: false }),

      // HEADER
      selectedChurch: ({ value: null, disabled: false }),
      selectedService: ({ value: null, disabled: false }),

      // FORM
      selectedStoreList: ({ value: null as StoreSupRelationVO[], disabled: false }),
      selectedStoreListSuggestions: ({ value: null as StoreSupRelationVO[], disabled: false }),
      selectedOriginCoord: ({ value: null as StoreSupRelationVO, disabled: false }),
      selectedFinalCoord: ({ value: null as StoreSupRelationVO, disabled: false }),
      selectedLstEpgByFinalCord: ({ value: null as SchoolFpgDataVO[], disabled: false }),
      selectedCommentsTransfer: ({ value: null, disabled: false }),

      selectedWorkshopEPG: ({ value: null as WorkshopVO, disabled: false }),
      selectedWorkshopEPGSchoolFpg: ({ value: null as WorkshopVO, disabled: false }),

      selectedOpenAssignedFolios: ({ value: null as OpenAssignedFolios, disabled: false }),

    });

    this.getConfigs();
  }

  /**
   * The function `getConfigs()` logs the values of `configForm` and `dataForm` in a formatted JSON
   * string.
   */
  getConfigs() {
    console.debug("✅ TRASPASO DE USUARIOS - FORMULARIO REACTIVO: " + JSON.stringify(this.globalUserDataFormParams.value, null, 2));
  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    this.getSecurity();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    console.debug("✅ TRASPASO DE USUARIOS - AUTHENTICATE BY ZUUL ");
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
            this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        error => {
          this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if the data is
   * not already available.
   */
  async getSecurity() {
    console.debug("✅ TRASPASO DE USUARIOS - GET SECURITY ");
    const securityControl = this.globalUserPreferencesParams || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (!securityControl) {
      const tokenProfile = (this.currentUser != null && this.currentUser.tokenProfile ? this.currentUser.tokenProfile : this.token) || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferencesParams.preferences = data;

      this.globalUserDataFormParams.patchValue({
        selectedGuide: this.globalUserPreferencesParams.preferences?.guideId + " " + this.globalUserPreferencesParams.preferences?.fullName,
      });
    } else {
      this.globalUserDataFormParams.patchValue({
        selectedGuide: this.globalUserPreferencesParams.preferences?.guideId + " " + this.globalUserPreferencesParams.preferences?.fullName,
      });

    }

    this.getTranslatedLabels();
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * .
   */
  async getTranslatedLabels() {
    console.debug("✅ TRASPASO DE USUARIOS - GET TRANSLATED LABELS ");
    const language = this.globalUserPreferencesParams?.preferences?.language || null;
    const region = this.globalUserPreferencesParams?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
      this.getLstCols();
      this.getLstColsOpen();
      await this.getLanguages();
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
    }
  }

  /**
   * The function `getLstCols` initializes an array `lstCols` with objects containing field and header
   * properties for a table.
   */
  getLstCols() {
    this.lstCols = [
      { field: 'schoolFPG.schoolId', header: this.translations.lbl_id },
      { field: 'schoolFPG.year', header: this.translations.lbl_period },
      { field: 'schoolFPG.name', header: this.translations.lbl_church },
      { field: 'schoolFPG.guideName', header: this.translations.lbl_guide_imparts },
      { field: 'schoolFPG.planedDate', header: this.translations.lbl_planned_date },
      { field: 'storeName', header: this.translations.lbl_coordination },
      { field: 'options', header: "" },
    ];
  }



  /**
 * The function `getLstColsOpen` initializes an array `lstColsOpenFolios` with objects containing field and header
 * properties for a table.
 */
  getLstColsOpen() {
    this.lstColsOpenFolios = [
      { field: 'assignedFolio.itemId', header: this.translations.lbl_id },
      { field: 'assignedFolio.descri', header: this.translations.lbl_description }
    ];
  }

  /**
     * The function asynchronously fetches store data and updates the global user data
     * form with the retrieved information.
     * @returns The function returns a boolean value (`true` or `false`) based on the
     * success of fetching store data and updating the `selectedCoordination` value in the
     * `globalUserDataForm`. If the store data is successfully fetched, it returns `true`. If there is an
     * error during the process, it returns `false`.
     */
  async getCoordination(storeId: string) {
    console.debug("✅ TRASPASO DE USUARIOS - GET COORDINATION ");
    try {

      if (!storeId) {
        console.warn('Missing required parameters: storeId and languageId are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetStoreById, {
        storeId
      });

      if (result.success) {

        this.globalUserDataFormParams.patchValue({
          selectedStore: result.data,
          selectedCoordination: result.data?.storeId + ' ' + result.data?.descri,
        });
        return true;
      } else {
        console.error("An error occurred while fetching coordination");
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function is an asynchronous function that fetches a list of languages and handles
   * any errors that occur during the process.
   */
  async getLanguages() {
    console.debug("✅ TRASPASO DE USUARIOS - LENGUAJES: ");

    const language = this.globalUserPreferencesParams?.preferences?.language || null;
    const storeId = this.globalUserPreferencesParams?.preferences?.storeId || null;

    try {
      const result = await this.tovpilCrudService.fetch(this.endPointLanguageByStoreId, { language, storeId });

      if (result.success) {
        this.languages = result.data;

        if (language && storeId) {
          let selectedLanguage = this.languages.find(o => o.valueId === language);

          // NO EXISTE PARA ESA COORDINACION EL SELECCIONADO
          if (selectedLanguage == null && this.languages.length > 0) {
            selectedLanguage = this.languages[0];
          }

          this.globalUserDataFormParams.patchValue({
            selectedLanguage: selectedLanguage
          });

          await this.getInitData();
        }
      } else {
        console.error("An error occurred while fetching languages:", result);
        //this.messageService.add({ severity: 'warn', summary: this.translations.lbl_resource_not_found , detail: this.translations.lbl_language });
      }
    } catch (error) {
      console.error("An error occurred while fetching languages:", error);
      // this.messageService.add({ severity: 'warn', summary: this.translations.lbl_resource_not_found , detail: this.translations.lbl_language });
    }
  }

  /**
   * The  function fetches valid periods from a service and assigns them to a list, then
   * selects a default period and returns a boolean indicating success.
   * @returns a boolean value. It returns true if the data retrieval is successful (data.success is
   * true), and false if there is an error or the data retrieval is not successful.
   */
  async getValidPeriods(language: string) {
    console.debug("✅ TRASPASO DE USUARIOS - GET VALID PERIODS ");
    try {

      const data = await this.tovpilCrudService.fetch(this.endPointGetValidPeriods, language);

      if (!data.success) {
        return false;
      }
      const lstPeriod = data.data || []; // Handle empty data array

      const selPeriod = this.globalUserPreferencesParams?.preferences?.periodSelected ?? null;

      const selectedPeriod = selPeriod?.year
        ? lstPeriod.find(period => period.year === selPeriod.year && period.period === selPeriod.period)
        : lstPeriod[0]; // Default to first period if no selection or year missing

      this.periods = lstPeriod;

      this.globalUserDataFormParams.patchValue({
        selectedPeriod: selectedPeriod
      });

      return true;
    } catch (error) {
      console.error("Error in getValidPeriods:", error);
      return false;
    }
  }

  /**
   * The `getInitData` function fetches price list data, selected price data, and exchange rate data,
   * and then updates the form with the fetched data.
   */
  async getInitData() {
    console.debug("✅ TRASPASO DE USUARIOS - GET INIT DATA ");
    try {
      const language = this.globalUserPreferencesParams?.preferences?.language || null;
      const coordinationStoreId = this.globalUserPreferencesParams?.preferences?.storeId || null;


      const validPeriodsResponse = await this.getValidPeriods(language);
      const validCoordinationResponse = await this.getCoordination(coordinationStoreId);

      if (validPeriodsResponse && validCoordinationResponse) {
        await this.loadData();
      } else {
        console.error("An error occurred while fetching price list:", validPeriodsResponse);
      }
    } catch (error) {
      console.error("An error occurred while fetching price list:", error);
    }
  }

  /**
   * The `loadData` function is an asynchronous function that loads data from an API and displays a
   * message based on the validity of the form data.
   * @returns nothing.
   */
  async loadData() {
    console.debug("✅ TRASPASO DE USUARIOS - LOAD DATA ");
    if (this.globalUserDataFormParams.valid == false) {
      return;
    }

    try {
      this.blocked = true;

      // Ejecutar las peticiones en paralelo
      const [getFutureGuideData] = await Promise.all([
        this.getFutureGuideData(),
      ]);

      this.getConfigs();

      // Verifica si todas las respuestas son válidas
      if (getFutureGuideData) {
        this.blocked = false;
      } else {
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
    } finally {
      setTimeout(() => {
        this.blocked = false;
      }, 1500);
    }
  }

  /**
   * The function asynchronously reloads a list of guides, displaying an error
   * message if the operation fails.
   */
  async reloadFutureGuideData() {
    console.debug("✅ TRASPASO DE USUARIOS - RELOAD DATA ");
    try {
      this.blocked = true;
      const servsResponse = await this.getFutureGuideData();

      if (servsResponse) {
        this.blocked = false;
      } else {
        console.error("Error recargando list guide");
        this.messageService.add({ severity: 'warn', summary: this.translations.lbl_error + ' ' + this.translations.lbl_reload, detail: this.translations.lbl_try + ' ' + this.translations.lbl_again });
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      console.error("Error recargando list guide");
      this.messageService.add({ severity: 'warn', summary: this.translations.lbl_error + ' ' + this.translations.lbl_reload, detail: this.translations.lbl_try + ' ' + this.translations.lbl_again });
    } finally {
      setTimeout(() => {
        this.blocked = false;
      }, 1500);
    }
  }

  /**
   * The function `getFutureGuideData` is an asynchronous function that fetches a list of guides based on the
   * selected store, period, and year, and handles the success and error cases accordingly.
   * @returns a Promise.
   */
  async getFutureGuideData(): Promise<boolean> {
    console.debug("✅ TRASPASO DE USUARIOS - GET ALL DATA");

    const handleErrorMessage = (message: string, error: any): void => {
      console.error(message, error);
      this.handleError(`${this.translations.lbl_no} ${this.translations.lbl_information} ${this.translations.lbl_to} ${this.translations.lbl_process}, ${this.translations.lbl_try} ${this.translations.lbl_again}`);
    };

    try {
      const selStoreId: string | null = this.coordStoreId || null;

      const fetchFutureGuideData = async (): Promise<boolean> => {
        try {
          const result = await this.tovpilCrudService.fetch(this.endPoinGetAllEgpByStoreId, { storeId: selStoreId });

          if (result.success) {
            const filteredSchoolFpg = result.data.find((schoolFPG: any) => schoolFPG.schoolFPG.schoolId === this.schoolId) || null;

            this.globalUserDataFormParams.patchValue({ selectedSchoolFpg: filteredSchoolFpg });
            return true;
          }

          throw new Error("Error fetching future guide data");
        } catch (error) {
          handleErrorMessage("Error fetching future guide data:", error);
          return false;
        }
      };

      const fetchGuideData = async (): Promise<boolean> => {
        try {
          const result = await this.tovpilCrudService.fetch(this.endPoinGetGuideById, { guideId: this.guideId });

          if (result.success) {
            this.globalUserDataFormParams.patchValue({ selectedFutureGuide: result.data });
            return true;
          }

          throw new Error("Error fetching guide data");
        } catch (error) {
          handleErrorMessage("Error fetching guide data:", error);
          return false;
        }
      };

      const initDataHeader = async (): Promise<boolean> => {
        try {
          const selectedSchoolFpg = this.globalUserDataFormParams.get('selectedSchoolFpg')?.value;

          this.globalUserDataFormParams.patchValue({
            selectedChurch: selectedSchoolFpg
              ? `${selectedSchoolFpg.schoolFPG.schoolId} - ${selectedSchoolFpg.schoolFPG.name} - ${this.churchName}`
              : '',
            selectedService: this.translations ? this.translations.lbl_school_prep_guides : ''
          });

          return true;
        } catch (error) {
          handleErrorMessage("Error initializing data header:", error);
          return false;
        }
      };

      const openAssignedFolios = async (): Promise<boolean> => {
        try {
          const selectedLanguage = this.globalUserDataFormParams.get('selectedLanguage').value ?? "es";
          const result = await this.tovpilCrudService.fetch(this.endPointOpenAssignedFolios, {
            "language": selectedLanguage['valueId'],
            "method": "GET",
            "guide": {
              "guideId": this.guideId
            }
          });

          if (result.success) {
            const schools = result.data;
            this.globalUserDataFormParams.patchValue({
              selectedOpenAssignedFolios: schools.listFolios ?? []
            });

            return true;
          }

          throw new Error("Error fetching openAssignedFolios relation");
        } catch (error) {
          this.globalUserDataFormParams.patchValue({
            selectedOpenAssignedFolios: []
          });
          //handleErrorMessage("Error fetching openAssignedFolios relation:", error);
          return false;
        }
      };

      const findSupRelationByStoreIdFrom = async (): Promise<boolean> => {
        try {
          const selectedSchoolFpg = this.globalUserDataFormParams.get('selectedSchoolFpg')?.value;
          if (!selectedSchoolFpg || !selectedSchoolFpg.schoolFPG || !selectedSchoolFpg.schoolFPG.storeId) {
            console.warn("⚠️ Missing storeId in findSupRelationByStoreIdFrom:", selectedSchoolFpg);
            return false;
          }
          const result = await this.tovpilCrudService.fetch(this.endPointFindSupRelationByStoreId, { storeId: selectedSchoolFpg.schoolFPG.storeId });

          if (result.success) {
            this.globalUserDataFormParams.patchValue({
              selectedOriginCoord: result.data
            });

            return true;
          }

          throw new Error("Error fetching findSupRelationByStoreIdFrom");
        } catch (error) {
          handleErrorMessage("Error fetching findSupRelationByStoreIdFrom:", error);
          return false;
        }
      };


      const findSupRelationByName = async (): Promise<boolean> => {
        try {
          const result = await this.tovpilCrudService.fetch(this.endPointFindSupRelationByName, { descri: " " });

          if (result.success) {
            const schools = result.data;
            this.globalUserDataFormParams.patchValue({
              selectedStoreList: Array.isArray(schools) ? schools : schools ? [schools] : []
            });

            return true;
          }

          throw new Error("Error fetching supervisor relation");
        } catch (error) {
          handleErrorMessage("Error fetching supervisor relation:", error);
          return false;
        }
      };

      const fetchFutureGuideResponse = await fetchFutureGuideData();
      const fetchGuideResponse = await fetchGuideData();
      const initDataHeaderResponse = await initDataHeader();
      const findSupRelationByNameResponse = await findSupRelationByName();
      const findSupRelationByStoreIdFromResponse = await findSupRelationByStoreIdFrom();
      const openAssignedFoliosResponse = await openAssignedFolios();

      return fetchFutureGuideResponse && fetchGuideResponse && initDataHeaderResponse && findSupRelationByNameResponse && findSupRelationByStoreIdFromResponse && openAssignedFoliosResponse;

    } catch (error) {
      handleErrorMessage("Unexpected error in getFutureGuideData:", error);
      return false;
    }
  }

  /**
   * The function  filters a list based on a query string and updates the filtered
   * list accordingly.
   * @param event - The  function takes an `event` parameter, which is an object
   * containing a `query` property. The function filters a list based on the
   * `descri` property of each item in the list. The filtering is done by checking if the
   * @returns If the  function is called, it will return either an empty array
   * `[]` or a filtered list of items based on the `query` provided in the `event`. The filtered list
   * will be stored in the property of the object.
   */
  filterSupRelationList(event: { query?: string }): void {
    console.debug("✅ TRASPASO DE USUARIOS - FILTER COORDINATION");

    const selectedSchools: StoreSupRelationVO[] =
      this.globalUserDataFormParams.get('selectedStoreList')?.value ?? [];

    if (!Array.isArray(selectedSchools) || selectedSchools.length === 0) {
      console.warn("⚠️ No store found in selectedStoreList");
      this.globalUserDataFormParams.patchValue({ selectedStoreListSuggestions: [] });
      return;
    }

    const query = event.query?.toLowerCase() ?? '';

    if (typeof query !== 'string') {
      console.warn("⚠️ Invalid query:", event.query);
      return;
    }

    const filteredItems = selectedSchools.filter(item =>
      item?.descri?.toLowerCase().includes(query)
    );

    this.globalUserDataFormParams.patchValue({
      selectedStoreListSuggestions: filteredItems.length > 0
        ? filteredItems
        : selectedSchools.slice(0, 10)
    });
  }

  /**
   * The function updates the timeline data based on certain properties of
   * and `globalUserDataFormParams`.
   */
  async updateFinalEPG(value: unknown): Promise<void> {
    console.debug("✅ TRASPASO DE USUARIOS - UPDATING FINAL EPG");

    this.globalUserDataFormParams.patchValue({ selectedWorkshopEPGSchoolFpg: null });

    const selStoreId: string | null = (this.globalUserDataFormParams.get('selectedFinalCoord').value)?.storeId || null;

    const handleErrorMessage = (message: string, error: any): void => {
      console.error(message, error);
      this.handleError(`${this.translations.lbl_no} ${this.translations.lbl_information} ${this.translations.lbl_to} ${this.translations.lbl_process}, ${this.translations.lbl_try} ${this.translations.lbl_again}`);
    };

    const fethEPGByCoordSelected = async (): Promise<boolean> => {
      try {
        const result = await this.tovpilCrudService.fetch(this.endPoinGetAllEgpByStoreId, { storeId: selStoreId });

        if (result.success) {
          this.globalUserDataFormParams.patchValue({ selectedLstEpgByFinalCord: result.data });
          return true;
        }

        throw new Error("Error fetching future guide data");
      } catch (error) {
        handleErrorMessage("Error fetching future guide data:", error);
        return false;
      }
    };

    const fethEPGByCoordSelectedResponse = await fethEPGByCoordSelected();
  }

  /**
   * The function `onSelectWorkshop` checks for workshop data in a form and sets the selected workshop
   * based on a given key.
   * @param {string} workshopKey - The `onSelectWorkshop` function you provided seems to handle the
   * selection of a workshop based on a given `workshopKey`. The function first checks if
   * `globalUserDataFormParams` is available, and if not, it sets the selected workshop value to null and
   * logs a warning.
   * @returns The function `onSelectWorkshop` is returning `void`, which means it does not return any
   * value.
   */
  onSelectWorkshop(workshopKey: string): void {

    if (!this.globalUserDataFormParams) {
      this.globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg')?.setValue(null);
      console.warn(" ⚠️ Formulario no disponible.");
      return;
    }

    const epgs: SchoolFpgDataVO[] = this.globalUserDataFormParams.get('selectedLstEpgByFinalCord').value ?? [];

    if (!Array.isArray(epgs) || epgs.length === 0) {
      console.warn(" ⚠️ No hay datos en 'selectedLstEpgByFinalCord'.");
      this.globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg')?.setValue(null);
      return;
    }

    const filteredSchoolFpg = epgs.find((schoolFPG: any) =>
      schoolFPG?.wrks01?.f0?.wrksId === workshopKey ||
      schoolFPG?.wrks02?.f0?.wrksId === workshopKey ||
      schoolFPG?.wrks03?.f0?.wrksId === workshopKey
    ) || null;

    if (!filteredSchoolFpg) {
      console.warn(` ⚠️ No se encontró un workshop con el ID: ${workshopKey}`);
    }

    this.globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg')?.setValue(filteredSchoolFpg);
  }

  /**
   * The function sets the variable
   * to true.
   */
  openModelTransferGuideToNewCoordination() {
    this.displayModalConfirmation = true;
  }

  /**
   * The function is intended to transfer a guide to new coordination.
   */
  transferGuideToNewCoordination() {

    let oldSchoolId = this.globalUserDataFormParams.get('selectedChurch').value.split(" ")[0];
    let language = (this.globalUserDataFormParams.get('selectedLanguage').value)?.valueId || null;
    let guideAddr = {
      guide: this.globalUserDataFormParams.get('selectedFutureGuide').value["guideId"]
    }
    let req = {
      schoolId: this.globalUserDataFormParams.get('selectedWorkshopEPGSchoolFpg').value["schoolFPG"].schoolId,
      oldSchoolId: oldSchoolId,
      guideAddr: guideAddr,
      language: language,
      comment: this.globalUserDataFormParams.get('selectedCommentsTransfer').value,
      method: 'TRANSFER',
    }

    this.apiService.getCreateUpdateCancelSchoolEnrollFG(req).then(
      data => {
        if (data.status == 'OK') {
          this.displayModalConfirmation = false;
          //this.loadParticipants();
          this.messageService.add({
            severity: 'success', summary: this.translations.lbl_updated_data, detail: '', life: 3000
          });

        } else {
          this.displayModalConfirmation = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.errorMessage, life: 9000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error, life: 3000 });
      });
  }

  /**
   * The handleError function logs an error message to the console and adds an error message to the
   * message service.
   * @param {string} message - The `message` parameter is a string that represents the error message that
   * occurred while parsing.
   */
  async handleError(message: string) {
    console.error("An error occurred while parsing.");
    this.messageService.add({
      severity: 'warn',
      summary: 'Error',
      detail: message,
      life: 5000
    });
  }

  /**
   * The function "capitalizeLastElement" takes a string as input and returns the same string with the
   * last element capitalized.
   * @param {string} str - The parameter `str` is a string that represents the input string.
   * @returns the result of calling the `capitalizeLastElement` method of the `tovpilCrudService` object
   * with the `str` parameter.
   */
  capitalizeLastElement(str: string): string {
    return this.tovpilCrudService.capitalizeLastElement(str);
  }

  /**
   * The function `getNestedValue` retrieves a nested value from an object using a specified field.
   * @param {any} obj - The `obj` parameter is an object from which you want to retrieve a nested value.
   * @param {string} field - The `field` parameter is a string that represents the path to a nested value
   * in the `obj` object.
   * @returns The `getNestedValue` function is returning the value of the nested field in the given
   * object.
   */
  getNestedValue(obj: any, field: string): any {
    return this.tovpilCrudService.getNestedValue(obj, field);
  }

  /**
   * The goBack function closes the current window.
   */
  async goBack() {
    try {
      window.close();
    } catch (error) {
      console.error("An error occurred while navigating:", error);
      //this.handleError('Redirigir a CX4', 'Algo salió mal al redirigir a CX4');
    }
  }

  /**
     * This function redirects the user to the "school fg participant" page in a guide section.
     */
    redirectSchoolFGParticipant() {
      const delay = new Promise((resolve) => setTimeout(resolve, 1000));
      delay.then(() => {
        const navigationExtras: NavigationExtras = {
        };
        this.router.navigate(['catalogs/eppgs/schoolfpgParticipant'], navigationExtras);
      });
    }

  /** MANAGE PREFERENCES */

  /**
   * The `onChangeUserPreferences` function updates user preferences including language, period, and
   * currency, and then updates the user preferences entity, cookie, and triggers a reload.
   */
  async onChangeUserPreferences() {

    //console.debug("VIDEOPLAYER - ON CHANGE USER PREFERENCES: ")
    await this.refreshPreferences();

    // RECARGA
    this.initConfigs();
  }

  /* The above TypeScript code is updating properties of a user object, specifically setting the
      languageId, currencyId, periodYear, and periodMonth based on the provided values or null if not
      provided. It also updates the periodSelected property with the provided period value. Finally,
      it updates a cookie named "userPreferences" with the updated globalUserPreferences object using
      a cookie service. */
  async refreshPreferences() {
    // SOLO SE ACTUALIZA LA COOKIE
    let language = (this.globalUserDataFormParams.get('selectedLanguage').value)?.valueId || null;
    let period = (this.globalUserDataFormParams.get('selectedPeriod').value) || null;
    let currency = (this.globalUserDataFormParams.get('selectedCurrency').value)?.valueId || null;

    // ACTUALIZAMOS PROPIEDADES DE USUARIO
    this.userPreferencesService.updateTovpilCookie(
      null, // _levelId
      null, //_userId
      null, //_storeId
      null, //_id
      language || null, //_language
      currency || null, //_selCurrency
      null, //_coordinationId
      null, //_coordinationStack
      period?.year || null, //_selYear
      period?.period || null, //_selPeriod
      null, //_device
      null, //_storeSelected
      period, //_periodSelected
      null //_stores
    );
  }

  /* The above code is a TypeScript method that uses a `@HostListener` decorator to listen for the
  `resize` event on the window. When the window is resized, the `checkScreenSize` method is called,
  which checks the width of the window. If the window width is less than or equal to 768 pixels, it
  sets the `isMobile` property of the class to `true`, indicating that the screen size is considered
  to be mobile. */
  @HostListener('window:resize', [])
  checkScreenSize() {
    this.isMobile = window.innerWidth <= 768;
  }

  /**
   * The function `convertDateFormat` takes a string in the format "YYYYMMDD" and returns a string in the
   * format "DD-MM-YYYY".
   * @param {string} originalDateStr - The originalDateStr parameter is a string representing a date in
   * the format "YYYYMMDD".
   * @returns a string in the format "day-month-year".
   */
  convertDateFormat(originalDateStr: string): string {
    if (!/^\d+$/.test(originalDateStr)) {
      return "Fecha no disponible";
    }

    const year = originalDateStr.substr(0, 4);
    const month = originalDateStr.substr(4, 2);
    const day = originalDateStr.substr(6, 2);

    return `${day}-${month}-${year}`;
  }

  /**
   * This function formats a given date string into a specific format using the datePipe module in
   * TypeScript.
   * @param {string} dateString - A string representing a date in any valid format (e.g. "2021-10-15" or
   * "Oct 15, 2021").
   * @returns The function `formatDate` is returning a formatted date string in the format of
   * 'dd-MM-yyyy'. The input parameter `dateString` is being passed to the `datePipe.transform` method to
   * format the date. The formatted date string is then returned by the function.
   */
  formatDate(dateString: string) {
    const formattedDate = this.datePipe.transform(this.tovpilUtils.convertStringToDate(dateString), 'yyyy-MM-dd');
    return formattedDate;
  }
}
